<template>
    
    <div id="dvtop">   
        <centralnotificacao></centralnotificacao>        
        <nav id="navbarmenu" class="navbar  navbar-expand-md bg-light navbar-light" style="background-color: white !important;">
            <!-- <a class="navbar-brand" id="fantasia-filial" @click.prevent="openNav()" href="#">{{ filial.fantasia }}</a> -->
            <div class="collapse navbar-collapse" id="collapsibleNavbar">
                <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
                </ul>
            </div>
            <span class="navbar-text">
                <ul id="lst-icones-menu-nav">
                    <!-- <li>
                        <span class="icone-menu-bar" @click.prevent="mtdcentralnotificacao()" title="Central de notificações"><i class="fa fa-flag"></i></span>                        
                    </li>  -->
                    <!-- <li>
                        <span class="icone-menu-bar" @click.prevent="mtdrotinascoletor()" title="Coletor de produtos"><i class="fa fa-inbox"></i></span>                        
                        <span v-show="lstitenscoletor.length > 0" class="badge badge-pill badge-warning badge-itens-coletor">{{lstitenscoletor.length}}</span>
                    </li>                     -->
                    <li>
                        <div class="dropdown">
                            <span class="icone-menu-bar" aria-expanded="false" title="Notificações" data-toggle="dropdown">
                                <span class="bolinha-notificacao">
                                    <i style="font-size: 14px;" class="fa fa-bell"></i>
                                    <span v-show="qtdnotificacoes > 0" style="    top: 26px;
    left: -14px;" class="badge badge-pill badge-danger badge-notfusu">{{qtdnotificacoes}}</span>
                                </span>
                                
                            </span>
                            <div v-show="qtdnotificacoes > 0" class="dropdown-menu drop-notificacoes animate slideIn">
                                <div class="container-fluid" style="padding: 0px;">
                                    <ul class="list-group" style="width: 100%;">
                                        <li class="list-group-item" active>
                                            <i class="fa fa-bell"></i> Notificações
                                            <span id="limpar-notificacao" @click.prevent="mtdlimparnotificacoes(0)">Limpar tudo</span>
                                        </li>
                                        <div style="max-height: 273px; overflow: auto;">
                                            <li v-for="(notificacao, indice) in lstnotificacoes" :key="indice" @click.prevent="mtddetalhesnotificacao(notificacao)" class="list-group-item list-group-item-action" style="padding-bottom: 20px; cursor: pointer;">
                                                <template v-if="parseInt(notificacao.tipo) === 1">
                                                    <span><i class="fa fa-certificate" style="font-size: 22px; color: #f82b54;"></i></span>
                                                </template>                                            
                                                <template v-else>
                                                    <img  v-bind:src="pathfotos+notificacao.foto" class="img-usutarefa img-usuario-notificacao" data-toggle="tooltip" v-bind:title="'Registrada por: '+notificacao.nomeusu">
                                                </template>
                                                <span class="tit-notificacao" v-bind:title="notificacao.descnotificacao">{{ notificacao.descnotificacao }}</span>
                                                <span class="data-notificacao">{{ notificacao.dtemissao }}</span>
                                            </li>

                                            <!-- <li v-for="(titulo, indice) in lstBoletosDisp" :key="indice" class="list-group-item list-group-item-action" style="padding-bottom: 20px;">
                                                
                                                <span v-if="titulo.diretoriotitulo===''||titulo.diretoriotitulo===null"><i class="fa fa-qrcode"  style="font-size: 22px; margin-top: 10px; margin-left: 5px; cursor: pointer;" @click.prevent="mtdpagamentopix(titulo)" title="Pagar via PIX"></i></span>
                                                <span v-else><i class="fa fa-barcode" style="font-size: 22px; color: #0acf97; margin-top: 10px;  cursor: pointer;" @click.prevent="mtdimprimirboleto(titulo)" title="Pagar via boleto"></i></span>
                                                <span class="tit-notificacao"  style="left: 75px;">Fatura disponível</span>
                                                <span class="data-notificacao" style="left: 75px;">Vencimento: {{ titulo.dtventit }}</span>
                                            </li> -->

                                            <li v-for="(titulo, indice) in titulopagar" :key="indice" class="list-group-item list-group-item-action" style="padding-bottom: 20px;">
                                                
                                                <span><i class="fa fa-qrcode"  style="font-size: 22px; margin-top: 10px; margin-left: 5px; cursor: pointer;" @click.prevent="goToCasualPayment()"></i></span>
                                                <span class="tit-notificacao"  style="left: 75px;">Fatura disponível({{ formatarData(titulo.dtventit) }})</span>
                                                <span class="data-notificacao" style="left: 75px;">{{ titulo.codtit }}</span>
                                            </li>
                                        </div>
                                    </ul>
                                </div>
                            </div>                            
                        </div>
                    </li>
                    <!-- <li>
                        <span class="icone-menu-bar" @click.prevent="mtdlogoff()" title="Sair">
                            <span class="bolinha-notificacao"><i class="fa fa-sign-out"></i>
                            </span>
                        </span>                        
                    </li> -->
                </ul>
            </span>            
        </nav>
        <div id="mySidenav" @mouseleave="closeNav" class="sidenav">
            <div id="dvconteudo-side-nav" class="container-fluid" style="display: none;">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 dv-borda-bottom">
                        <img  class="img-fluid" src="../assets/logosis.png">
                        <span href="#" class="closebtn" @click.prevent="closeNav">&times;</span>                        
                    </div>
                    <div class="col-md-12 dv-borda-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="input-group">
                                    <input type="text" class="form-control" id="edpesquisamenu" v-model="vcontpesqrapida" placeholder="Pesquisar..." autocomplete="off">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="btpesquisarmenu">
                                        <i class="fa fa-search" aria-hidden="true"></i>
                                    </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="lstlistaresultado.length > 0" class="col-md-12" style="margin-top: 2px;">
                                <ul class="grupo-lista-pesquisa" style="margin-bottom: 0px;">
                                    <li v-for="(item, index) in lstlistaresultado" v-bind:key="index" style="list-style-type: none; padding: 0px; min-height: 20px;">
                                        <router-link v-bind:to="item.link">{{item.menu.toUpperCase()}}</router-link>
                                    </li>
                                </ul>
                            </div>                        
                        </div>
                    </div>
                    <div class="col-md-12 dv-borda-bottom" style="padding-top: 5px;">
                        <div class="row">
                            <div class="col-md-12">
                                <h6 style="font-size: 12px; font-weight: bold; color: #2c5569;">MENU</h6>
                            </div>
                            <div class="col-md-12" style="padding: 0px; margin-bottom: -16px;">
                                <ul v-show="menuindividual.length >= 0" id="grupo-lista-menu">
                                    <template v-for="(menu, index) in menuindividual">
                                        <li v-if="parseInt(menu.habilita) === 1" v-bind:key="index">
                                            <a data-toggle="collapse" v-bind:href="'#menu'+index"><span class="icone-menu"><i v-bind:class="menu.icone"></i></span> {{primeiramaiuscula(menu.menu)}}<i class="fa fa-chevron-right icone-rotate"></i></a>
                                            <ul class="grupo-lista-submenu collapse" v-bind:id="'menu'+index">
                                                <li>
                                                    <template v-for="(item, indexi) in menu.submenu">
                                                        <template v-if="item.menu !== '-'">
                                                            <router-link v-bind:key="indexi" v-if="parseInt(item.habilita) === 1" v-bind:to="item.link">{{primeiramaiuscula(item.menu)}}</router-link>
                                                        </template>                                                        
                                                    </template>
                                                </li>                                            
                                            </ul>
                                        </li>
                                    </template>    
                                </ul>                                
                            </div>
                        </div>
                    </div>
                    <div style="padding-top: 30px;" class="col-12 col-sm-12 col-md-12">
                        <span class="icone-menu-bar" @click.prevent="mtdlogoff()" title="Sair">
                            SAIR 
                        </span>                        
                    </div>
                </div>
            </div>  
            <div id="dvconteudo-side-nav-mini" class="container-fluid" >
                <div class="row">
                    <!-- <div class="col-md-12" style="padding-top: 15px; padding-bottom: 15px;">
                        <div class="row">
                            <div class="col-md-12">
                                <h6 style="font-size: 12px; padding-left: 0px; font-weight: bold; color: #2c5569;">MENU</h6>
                            </div>                        
                        </div>
                    </div> -->
                    <div class="col-12 col-sm-12 col-md-12">
                        <img  class="img-fluid" src="../assets/logo.png">
                                  
                    </div>
                    <div style="padding-top: 30px;" class="col-12 col-sm-12 col-md-12">
                    </div>
              
                    <div class="col-md-12" style="padding-top: 5px;" @mouseover="openNav">
                        <div class="row">
                            
                            <div class="col-md-12" style="padding: 0px; margin-bottom: -16px;" >
                                <ul v-show="menuindividual.length >= 0" id="grupo-lista-menu">
                                    <template v-for="(menu, index) in menuindividual">
                                        <li v-if="parseInt(menu.habilita) === 1" v-bind:key="index">
                                            <a style="padding-left: 17px;" data-toggle="collapse" v-bind:href="'#menu'+index"><span class="icone-menu"><i v-bind:class="menu.icone"></i></span></a>
                                        </li>
                                    </template>    
                                </ul>                                
                            </div>
                        </div>
                    </div>

                    <div style="padding-top: 30px;" class="col-12 col-sm-12 col-md-12">
                        
                        <span class="icone-menu-bar" @click.prevent="mtdlogoff()" title="Sair">
                            <span class="bolinha-notificacao"><i class="fa fa-sign-out"></i>
                            </span>
                        </span>                        
                          
                    </div>
                </div>
            </div>           
        </div>
        <!-- Modal para visualização do detalhe da notificação -->
        <div class="modal fade" id="mdldetnotificacao" tabindex="-1" role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalScrollableTitle" style="font-size: 18px;"><i class="fa fa-bell"></i> {{ detnotificacao.descnotificacao }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="jumbotron" style="margin-bottom: 0px; padding: 40px 15px 40px 15px;">
                                    <div class="row">
                                        <div class="col-md-12 text-center" style="margin-bottom: 15px;">
                                            <template v-if="parseInt(detnotificacao.tipo) === 1">
                                                <span><i class="fa fa-certificate icon-validade-cert"></i></span>
                                            </template>
                            
                                            <template v-else>
                                                <img v-if="detnotificacao.foto !== 'undefined'" v-bind:src="pathfotos+detnotificacao.foto" class="img-usutarefa img-usuario-notificacao" style="width: 60px!important; height: 60px!important;">
                                            </template>
                                        </div>
                                        <div class="col-md-12" style="margin-bottom: 10px;">
                                            <h6 v-if="parseInt(detnotificacao.tipo) === 1">Emissão: {{ detnotificacao.dtemissao }}, por Purple.</h6>                                            
                                            <h6 v-else>Emissão: {{ detnotificacao.dtemissao }}, por {{ detnotificacao.nomeusu }}.</h6>                                            
                                        </div>
                                    
                                        <div id="conteudonotif" class="col-md-12">
                                            <p>{{ detnotificacao.conteudonotificacao }}</p>                                            
                                            <p v-if="parseInt(detnotificacao.tipo) === 0"><strong>Tarefa:</strong> {{ detnotificacao.titulotarefa }}</p>                                            
                                        </div>                                                                                                                                                                               
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>
                </div>
            </div>
        </div>
         <!-- Modal para visualização do detalhe da notificação personalizada - guga 🤠 -->
        <div class="modal fade" id="mdldetnotificacaouser" tabindex="-1" role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content" style="margin: -5px;">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalScrollableTitle" style="font-size: 18px;"><i :class="detnotificacao.adesivo"></i> {{ detnotificacao.descnotificacao }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify">
                        <div class="container-fluid">
                            <div class="row">
                                <div style="width: 100%;" class="row">
                                    <div class="col-3">
                                        <div class="col-md-12 text-center jumbotron d-flex align-items-center justify-content-center" style="padding-top: 6px; padding-bottom: 8px; border-radius: 100%; width: 68px;">
                                            <i style="font-size: 50px; " :class="detnotificacao.adesivo +' '+detnotificacao.cor"></i>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="col-md-12 text-center" style="padding-top: 20px;">
                                            <h6>{{ detnotificacao.descnotificacao }}</h6> 
                                        </div>
                                    </div>
                                    <div style="width: 100%; align-items: center;" class="col-3">
                                        <div class="row d-flex align-items-center justify-content-center">
                                            <img v-if="detnotificacao.foto !== 'undefined'" v-bind:src="pathfotos+detnotificacao.foto" class="img-usutarefa img-usuario-notificacao" style="width: 35px!important; height: 35px!important; ">
                                            <span style="font-size: 8px; text-align: center; width: 100%;">Emissão: {{ detnotificacao.dtemissao }}, por {{ detnotificacao.nomeusu }}.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="jumbotron" style="margin-bottom: 0px; padding: 40px 15px 40px 15px; width: 100%;">
                                    <div class="row">
                                        <div id="conteudonotifexp" class="col-md-12">
                                              
                                        </div>                                                                                                                                                                               
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal pra redefinição de senha e foto do usuário -->
        <div class="modal fade" id="mddefinicoesusuario">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" style="font-size: 16px;">Definições do usuário</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="col-md-12 text-center border rounded" style="padding-top: 10px; padding-bottom: 10px;">
                                    <img id="img-usuario-def" class="img-thumbnail" 
                                    v-bind:src="pathfotovisualizar+usuario.foto" 
                                    data-toggle="tooltip" 
                                    title="Clique na foto para alterar" 
                                    data-placement="bottom"
                                    @click="$refs.if_imgusuariodef.click()">
                                    <div class="col-md-12 text-center">
                                        <input type="file" 
                                        accept="image/png, image/jpeg"
                                        id="btselecionarimagemusudef" 
                                        @change="mtdselecionarimagemusuariodef" 
                                        style="display: none;"
                                        ref="if_imgusuariodef">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <label for="edsenhaantigadef">Senha antiga:</label>
                                <input type="password" class="form-control form-control-sm" id="edsenhaantigadef" v-model="asenha_antiga" data-bv-group=".group" maxlength="20">
                            </div>
                            <div class="col-md-12">
                                <label for="edsenhanovadef">Nova senha:</label>
                                <input type="password" class="form-control form-control-sm" id="edsenhanovadef" v-model="asenha_nova" data-bv-group=".group" maxlength="20">
                            </div>
                            <div class="col-md-12">
                                <label for="edsenhaconfirmadef">Confirmar senha:</label>
                                <input type="password" class="form-control form-control-sm" id="edsenhaconfirmadef" v-model="asenha_repete" data-bv-group=".group" maxlength="20">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="#" id="btalterarsenhausudef" class="btn btn-primary btn-sm" role="button" style="min-width: 100px;" @click.prevent="mtdalterarsenhausuario()"><i class="fa fa-check-circle"></i> Confirmar</a>
                        <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal" style="min-width: 100px;"><i class="fa fa-close"></i> Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal do coletor de produtos -->
        <div class="modal fade" id="mdlcoletor" tabindex="-1" role="dialog" aria-labelledby="titulocoletor" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="titulocoletor" style="font-size: 18px;"><i class="fa fa-inbox"></i> Coletor de produtos</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12" style="margin-top: 10px;">
                                    <vue-bootstrap4-table
                                            :rows="lstitenscoletor"
                                            :columns="columns"
                                            :config="config"
                                            :classes="classes">
                                        <template slot="empty-results">
                                            <div class="col-md-12 text-center">Sem dados para visualização</div>
                                        </template>
                                        <!-- ícones de ordenação da table -->
                                        <template slot="sort-asc-icon">
                                            <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                        </template>
                                        <template slot="sort-desc-icon">
                                            <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                        </template>
                                        <template slot="no-sort-icon">
                                            <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                        </template>                                    
                                        <!--  -->                                    
                                        <template slot="slot_idproduto" slot-scope="item">
                                            {{ item.row.idproduto }}
                                        </template>
                                        <template slot="opcoes" slot-scope="item">
                                            <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalteraritemcoletor(item.row)"><i class="fa fa-edit"></i></button>
                                            <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdrotinaitemcoletor(item.row, 3, 0)"><i class="fa fa-trash"></i></button>
                                        </template>
                                    </vue-bootstrap4-table>
                                </div>                                
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" style="width: 140px;" @click.prevent="mtdlimparcoletor()"><i class="fa fa-eraser"></i> Limpar coletor</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 140px;"><i class="fa fa-close"></i> Fechar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal do coletor para edição de quantidade -->
        <div class="modal fade" id="mdleditaitemcoletor" tabindex="-1" role="dialog" aria-labelledby="titulocoletoritem" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="titulocoletoritem" style="font-size: 18px;"><i class="fa fa-edit"></i> Alteração de quantidade</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12">
                                    <label for="edqtdcoletor">Quantidade:</label>
                                    <money class="form-control form-control-sm" id="edqtdcoletor" 
                                        v-model="qtditemalteracaocoletor"
                                        data-bv-group=".group" style="text-align:right;"></money>
                                </div>                                 
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdrotinaitemcoletor(itemalteracaocoletor, 5, qtditemalteracaocoletor)"><i class="fa fa-check"></i> Confirmar</button>
                    </div>
                </div>
            </div>
        </div>        
        <!-- Modal regualização -->
        <div class="modal fade" id="mdlregularizar" role="dialog" aria-hidden="true" data-backdrop="static">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body text-justify">
                        <div class="jumbotron" style="margin-bottom: 0px;">
                            <div class="container-fluid">
                                <div class="row"> 
                                  
                                    <div class="col-md-12 text-justify">
                                        <i style="font-size: 70px; color:#f82b54" class="fa fa-ban"></i>
                                        <p style="font-size: 20px;">Atenção Caro cliente,<br>
                                            Seu sistema esta bloqueado por falta de pagamento. Aperte no botao abaixo para efeuar o seu pagamento<br>
                                        </p>
                                    </div>
                                   
                                    <div class="col-md-12 text-center">
                                        <a href="#" class="btn btn-success" @click.prevent="goToCasualPayment()">Pagar fatura</a>
                                    </div>                                               
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>       
        
        <div class="modal fade" id="mdlembretepagamento" role="dialog" aria-hidden="true" data-backdrop="static">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body text-justify">
                        <div class="jumbotron" style="margin-bottom: 0px;">
                            <div class="container-fluid">
                                <div class="row"> 
                                  
                                    <div class="col-md-12 text-justify">

                                        <p style="font-size: 20px;">Atenção Caro cliente,<br>
                                            Até o momento não identificamos o pagamento de sua fatura, caso ja efetuou desconsidere<br>
                                        </p>
                                    </div>
                                   
                                    <div class="col-md-12 text-center">
                                        <a href="#" class="btn btn-success" @click.prevent="goToCasualPayment()">Pagar fatura</a>
                             
                                        <a href="#" class="btn btn-success" data-dismiss="modal"> Já paguei</a>
                                    </div>                                                  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 

        <div class="modal fade" id="mdfimdemo" role="dialog" aria-hidden="true" data-backdrop="static">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body text-justify">
                        <div class="jumbotron" style="margin-bottom: 0px;">
                            <div class="container-fluid">
                                <div class="row"> 
                                  
                                    <div class="col-md-12 text-justify">

                                        <p style="font-size: 20px;">Querido cliente,<br>
                                            Esperamos que você tenha aproveitado seu período de teste gratuito! Queremos informá-lo que o seu período de teste terminou e para continuar desfrutando de nossos serviços, é necessário concluir o pagamento da assinatura.

Para facilitar, você pode clicar no botão abaixo para finalizar o pagamento e continuar usufruindo dos benefícios do nosso serviço:<br>
                                        </p>
                                    </div>
                                   
                                    <div class="col-md-12 text-center">
                                        <a href="#" class="btn btn-success" @click.prevent="goToFirstPayment()">Pagar fatura</a>
                                    </div>  
                                    <div class="col-md-12 text-justify">

                                        <p style="font-size: 20px;">Se tiver alguma dúvida ou precisar de ajuda, nossa equipe de suporte está à disposição para ajudar. Entre em contato pelos canais de atendimento ao cliente.

Agradecemos por escolher nossos serviços e esperamos continuar proporcionando uma excelente experiência para você!
                                        </p>
                                    </div>                                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>
<script>
    import util from '../utilitarios/util.js'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import centralnotificacao from '../components/cmpcentralnotificacao.vue';
    export default {
        name: "menutop",
        components:{
            VueBootstrap4Table,
            centralnotificacao
        },        
        data: function () {
            return {
                pathfotos           : this.$store.state.configpaths.pathimagens,
                lstpesquisa         : [],
                lstlistaresultado   : [],
                qtdnotificacoes     : 0,
                titulopagar         : [],
                lstnotificacoes     : [],
                detnotificacao      : [],
                lstitenscoletor     : [],
                menuapp             : [],
                menuindividual      : [],
                pathfotovisualizar  : this.$store.state.configpaths.pathimagens,
                vcontpesqrapida     : '',

                //variáveis de liberação do sistema
                lstBoletosDisp      : [],
                diasatraso          : 0,

                //alterações de senha e foto do usuário                
                asenha_antiga       : '',
                asenha_nova         : '',
                asenha_repete       : '',
                arqimgselecionado   : '',
                vfoto               : '',

                //variaveis do coletor
                itemalteracaocoletor: [],
                qtditemalteracaocoletor: 0,

                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "slot_idproduto",
                        row_classes: "def-col-idproduto",
                        row_text_alignment: "text-right",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Referência",
                        name: "referencia",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Qtd",
                        name: "qtd",
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Und",
                        name: "und",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Data/Hora",
                        name: "dthrinclusao",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }                
            };
        },
        methods: {
            goToFirstPayment() {
                alert("inicio");
                this.$router.push({ name: 'Payment', params: { type: 'first' } });
            },
            goToCasualPayment() {
                this.$router.push({ name: 'Payment', params: { type: 'casual' } });
            },
            formatarData(data) {
                // Verifica se a data está no formato esperado
              
                
                // Divide a string de data em ano, mês e dia
                const [ano, mes, dia] = data.split('-');
                
                // Retorna a data formatada como "dd/mm/aaaa"
                return `${dia}/${mes}/${ano}`;
            },
            primeiramaiuscula(texto){
                return util.primeiramaiuscula(texto);
            },
            mtdlogoff() {
                util.logoff(this);
            },
            rtcarregardadosusuario() {
                let vself           = this;

                vself.pathfotovisualizar  = vself.$store.state.configpaths.pathimagens;
                vself.pathfotos           = vself.$store.state.configpaths.pathimagens;
                
                let loader          = vself.$loading.show();

                let parametros      = [
                    {parametro: 'op',           valor : 'dadosusuario'},
                    {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
                    {parametro: 'idusuario',    valor : window.localStorage.getItem('idusuario')}
                ];
                let retorno     = util.reqaxios(parametros, 'post', window.localStorage.getItem('adrsrv')+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    //carrega os dados da filial padrão do usuário
                    let payloadf = {
                        idcliente        : window.localStorage.getItem('idcliente'),//id do cliente no sac
                        idclientepadrao  : response.data.filialpadrao.idcliente,//id do consumidor padrao para emissao dos pedidos
                        codfil           : response.data.filialpadrao.codfil,
                        descfil          : response.data.filialpadrao.descfil,
                        fantasia         : response.data.filialpadrao.fantasia,
                        formulacustopro  : response.data.filialpadrao.formulacustoproduto,
                        logo             : response.data.filialpadrao.logo,
                        idestoque        : response.data.filialpadrao.idestoque,
                        descestoque      : response.data.filialpadrao.descestoque,
                        nomecliente      : response.data.filialpadrao.nomecliente,
                        idplano          : response.data.filialpadrao.idplano,
                        tipoplano        : response.data.filialpadrao.tipoplano,
                        descplano        : response.data.filialpadrao.descplano,
                        idtabela         : response.data.filialpadrao.idtabela,
                        percentrada      : response.data.filialpadrao.percentrada,
                        permitedesconto  : response.data.filialpadrao.permitedesconto
                    };
                    
                    vself.$store.commit('MUDAR_DADOS_FILIAL',payloadf);



                    //Monta o menu do usuário
                    vself.menuapp           = [];
                    vself.menuindividual    = [];
                    vself.menuapp           = response.data.perfilusu;
                    vself.lstnotificacoes   = response.data.notificacoes;
                    vself.lstitenscoletor   = response.data.itenscoletor;                   
                    //vself.qtdnotificacoes   = vself.lstnotificacoes.length;
                    vself.$store.commit('MUDAR_PERFIL_USUARIO',vself.menuapp);

                    for (var i = 0; i < vself.menuapp.length; i++) {
                        var m = vself.menuapp[i]['codop'];
                        var f = m.indexOf(".");
                        if (f === -1) {
                            let menutmp = {
                                codop   : vself.menuapp[i]['codop'],
                                menu    : vself.menuapp[i]['descricao'],
                                habilita: vself.menuapp[i]['habilita'],
                                chave   : vself.menuapp[i]['chave'],
                                icone   : vself.menuapp[i]['icone'],
                                submenu : []
                            };
                            vself.menuindividual.push(menutmp);
                        }
                    }
                    for (var i = 0; i < vself.menuapp.length; i++) {
                        var m = vself.menuapp[i]['codop'];
                        var f = m.split(".");
                        if (f.length === 2) {
                            var p     = m.indexOf(".");
                            var codop = m.substring(0, p);
                            let menuitem  = {
                                menu    : vself.menuapp[i]['descricao'],
                                link    : vself.menuapp[i]['link'],
                                habilita: vself.menuapp[i]['habilita']
                            };
                            var ind = util.getArrayIndexForKey(vself.menuindividual, 'codop', codop);
                            vself.menuindividual[ind]['submenu'].push(menuitem);
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response);
                });
            },
            openNav(){
                // $("#navbarmenu").removeClass("fixed-top");
                $("#dvconteudoapp").css("margin-top", "22px");
                // $("#dvalertasistema").css("margin-top", "11px");
                // $("#dvalertasistema").css("margin-bottom", "25px");
                $('#dvconteudo-side-nav-mini').hide();
                document.getElementById("mySidenav").style.width = "250px";
                $('#dvconteudo-side-nav').fadeIn(700);
                this.mtdmontalstpesq();
                setTimeout(function(){
                    $('#edpesquisamenu').focus();
                },200);
            },
            closeNav(){
                $('#dvconteudo-side-nav').hide();
                document.getElementById("mySidenav").style.width = "50px";
                setTimeout(function(){
                    $('#dvconteudo-side-nav-mini').show();
                    // $("#navbarmenu").addClass("fixed-top");
                    $("#dvconteudoapp").css("margin-top", "20px");
                    // $("#dvalertasistema").css("margin-top", "65px");
                    // $("#dvalertasistema").css("margin-bottom", "-60px");
                }, 500);                
            },
            mtdmontalstpesq(){
                this.vcontpesqrapida     = '';
                this.lstpesquisa         = [];
                this.lstlistaresultado   = [];
                for (var i = 0; i < this.menuapp.length; i++) {
                    let chavetmp = [];
                    if (this.menuapp[i]['chave'] !== '') {
                        chavetmp = JSON.parse(this.menuapp[i]['chave']);                        
                        if (chavetmp.length > 0) {
                            for (var x = 0; x < chavetmp.length; x++) {
                                let item = {
                                    'chave': chavetmp[x],
                                    'menu': this.menuapp[i]['descricao'],
                                    'link': this.menuapp[i]['link'],
                                    'habilita': this.menuapp[i]['habilita']
                                };
                                if (item.habilita) {
                                    this.lstpesquisa.push(item);
                                }
                            }
                        }
                    }
                }
            },
            mtddetalhesnotificacao(notificacao) {
                this.detnotificacao = notificacao;

                if(parseInt(this.detnotificacao.tipo)===3){
                    $('#mdldetnotificacaouser').modal('show');
                    var divconteudo = document.getElementById("conteudonotifexp");
                    divconteudo.innerHTML = "";
                    divconteudo.innerHTML = this.detnotificacao.conteudonotificacao;
                   
                }else{
                    $('#mdldetnotificacao').modal('show');
                }
          
            },            
            mtdlimparnotificacoes(idnotificacao){//se for 0 marca todas como lida
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
                    {parametro: 'op',           valor : 'notificacaolida'},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'idnotificacao',valor : idnotificacao}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();                    
                    if ($.isNumeric(response.data)){
                        if (parseInt(idnotificacao) === 0){
                            vself.lstnotificacoes = [];
                        }else{
                            vself.lstnotificacoes.splice(util.getArrayIndexForKey(vself.lstnotificacoes, 'idnotificacao', idnotificacao), 1);
                        }
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.qtdnotificacoes= vself.lstnotificacoes.length + vself.lstBoletosDisp.length;
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtddefinicoesusuario(){
                this.closeNav();
                this.asenha_antiga       = '';
                this.asenha_nova         = '';
                this.asenha_repete       = '';                
                $('#mddefinicoesusuario').modal('show');
            },
            mtdalterarsenhausuario(){
                let vself = this;
                if (vself.asenha_antiga === ''){
                    this.$toastr.w('Informe sua senha antiga!', 'Atenção!');
                    $('#edsenhaantigadef').focus();
                    return;
                }  
                if (vself.asenha_nova === ''){
                    this.$toastr.w('Informe sua nova senha!', 'Atenção!');
                    $('#edsenhanovadef').focus();
                    return;
                }                              
                if (vself.asenha_nova !== vself.asenha_repete){
                    this.$toastr.w('Senha e senha de confirmação não conferem!', 'Atenção!');
                    $('#edsenhaconfirmadef').focus();
                    return;
                }
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
                    {parametro: 'op',           valor : 'defusuario'},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'pwold',        valor : vself.asenha_antiga},
                    {parametro: 'pwnew',        valor : vself.asenha_nova}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Senha alterada com sucesso!', 'Informação!');
                        $('#mddefinicoesusuario').modal('hide');
                        util.logoff(vself);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                $('#edsenhaantigadef').focus();
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                 
            }, 
            mtdselecionarimagemusuariodef(event){                
                let vself       = this;                 
                vself.arqimgselecionado = event.target.files[0];
                let loader      = vself.$loading.show();
                let localsalvar = vself.$store.state.configpaths.pathimgusuarios + vself.$store.state.filialpadrao.idcliente+'/'+vself.vdiretorioimagem;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqimgselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqimgselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.inf)){
                        vself.vfoto                = localsalvar+'/'+vself.arqimgselecionado.name;                        
                        vself.arqimgselecionado    = null;
                        vself.$toastr.s('Imagem enviada com sucesso!', 'Informação!');
                        $('#ipselecionarimgusuariodef').val('');

                        let loaderx = vself.$loading.show();
                        let parametros      = [
                            {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
                            {parametro: 'op',           valor : 'atzfoto'},
                            {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                            {parametro: 'foto',         valor : vself.vfoto}
                        ];
                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                        retorno.then(function (response) {
                            loaderx.hide();
                            if (!$.isNumeric(response.data)){
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                            }else{
                                $('#mddefinicoesusuario').modal('hide');
                                util.logoff(vself);                             
                            }
                        }).catch(function (response) {
                            loaderx.hide();
                            vself.$toastr.e('Erro ao enviar foto. Descrição do erro: '+response.message, 'Erro!');
                        });
                    }else{
                        loader.hide();
                        vself.vfoto             = '';                        
                        vself.arqimgselecionado = null;
                        $('#ipselecionarimgusuariodef').val('');
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }                   
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.vfoto             = '';                        
                    vself.arqimgselecionado = null;
                    $('#ipselecionarimgusuariodef').val('');
                });                
            },
            mtdrotinascoletor(){
                if (this.lstitenscoletor.length > 0){
                    $('#mdlcoletor').modal('show');
                }
            },
            mtdcentralnotificacao(){
                $('#mdcentralntificacao').modal('show');
            },
            mtdalteraritemcoletor(item){
                this.itemalteracaocoletor    = item;
                this.qtditemalteracaocoletor = item.qtd;
                $('#mdleditaitemcoletor').modal('show');
            },
            mtdlimparcoletor(){                
               util.rotinacoletor(this, [], 4, this.mtdlistaritenscoletor, this.$store.state.usuario.adrsrv);                
            },
            mtdrotinaitemcoletor(produto, op, qtd){
                if (parseInt(op) === 5){
                    if (parseFloat(qtd) <= 0){
                        this.$toastr.w('Quantidade inválida!', 'Atenção!');
                        $('#edqtdcoletor').focus();
                        return;
                    }                    
                    if (parseInt(produto.fracionado) === 0){
                        if (!Number.isInteger(qtd)){
                            this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
                            $('#edqtdcoletor').focus();
                            return;
                        }
                    }
                    $('#mdleditaitemcoletor').modal('hide');                    
                }
                let item = {
					'idproduto'             : produto.idproduto,
                    'qtd'                   : qtd
				};
                util.rotinacoletor(this, item, op, this.mtdlistaritenscoletor, this.$store.state.usuario.adrsrv);
            },            
            mtdlistaritenscoletor(itens){                
                if (itens.length === 0){
                  $('#mdlcoletor').modal('hide');  
                }                                             
                util.atzitenscoletor(this, itens, true);   
            },
            mtdverificaliberacaosistema(){
                let vself  = this; 
                let idclisac = vself.$store.state.filialpadrao.idcliente !== null ? vself.$store.state.filialpadrao.idcliente : window.localStorage.getItem('idcliente');
          
            },
            mtdverificademo(){
                let vself  = this; 
                let idclisac = vself.$store.state.filialpadrao.idcliente !== null ? vself.$store.state.filialpadrao.idcliente : window.localStorage.getItem('idcliente');
                if (idclisac !== null){                
                    let loader = vself.$loading.show();
                    let parametros      = [
                        {parametro: 'op',           valor : 'verificademo'},
                        {parametro: 'idcliger',    valor : idclisac}//id do cliente no sac
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                    retorno.then(function (response) {
                        loader.hide();
                        console.log("inicio")
                        if($.isNumeric(response.data.status)){
                           
                            switch (parseInt(response.data.status) ) {
                                
                                case 1:
                                    vself.qtdnotificacoes = vself.lstnotificacoes.length + 1;
                                    vself.titulopagar     = response.data.titulo;
                                    vself.$toastr.i("Você tem uma fatura disponivel, vide as notificações", 'Atenção!');
                                    break;
                                case 2:
                                    vself.qtdnotificacoes = vself.lstnotificacoes.length + 1;
                                    vself.titulopagar     = response.data.titulo;
                                    $('#mdlregularizar').modal('show');
                                    break;
                                    
                                case 3:
                                    vself.qtdnotificacoes = vself.lstnotificacoes.length + 1;
                                    vself.titulopagar     = response.data.titulo;
                                    vself.$toastr.w("Não identificamos o pagamento da sua mensalidade", 'Atenção!');
                                    vself.$toastr.w("Seu serviço pode ser cortado dentro de 5 dias ", 'Atenção!');
                                    $('#mdlembretepagamento').modal('show');
                                    break;    
                                case 4:
                                   
                                    $('#mdfimdemo').modal('show');
                                    break;    
                            
                              
                            }
                        }else{
                             vself.$toastr.w(response.data, 'Atenção!');
                        }
                    }).catch(function (response) {
                        loader.hide();                     
                    });    
                }
            },
        },
        mounted: function () { 
            let vself = this;       
            vself.pathfotos  = vself.$store.state.configpaths.pathimagens;
            this.mtdverificademo()
            $('#mdldetnotificacao').on('hidden.bs.modal', function () {
                vself.mtdlimparnotificacoes(vself.detnotificacao.idnotificacao);
            }); 
            $('#mdldetnotificacaouser').on('hidden.bs.modal', function () {
                vself.mtdlimparnotificacoes(vself.detnotificacao.idnotificacao);
            }); 
            $('#mddefinicoesusuario').on('shown.bs.modal', function () {
                $('#edsenhaantigadef').focus();
            }); 
            $('#mdleditaitemcoletor').on('shown.bs.modal', function () {
                $('#edqtdcoletor').focus();
            });
            vself.closeNav();
        },
        computed: {
            filial() {
                return this.$store.state.filialpadrao;
            },
            usuario(){
                this.rtcarregardadosusuario();                        
                return this.$store.state.usuario;                               
            },
            situacaosidenav(){             
                return this.$store.state.sidenav.fechar;                
            },
            atzcoletor(){
                return this.$store.state.atzcoletor.atualizar;
            },
            verificarlib(){
                return this.$store.state.verificalib.verificar;
            }            
        },
        watch:{
            vcontpesqrapida(val) {
                if (val.toUpperCase() !== ''){
                    this.lstlistaresultado = $.grep(this.lstpesquisa, function(element){
                        return element.chave.toUpperCase().indexOf(val.toUpperCase()) !== -1;
                    });
                }else{
                    this.lstlistaresultado = [];
                }
            },
            situacaosidenav(val){
                if (val === true){
                   this.closeNav();
					let payloads = {
						fechar    : false			
					};
					this.$store.commit('SIDE_NAV_CHANGE',payloads);                                       
                }
            },
            usuario(val){
                if (parseInt(val.definirsenhalogin) === 1){
                    this.mtddefinicoesusuario();
                }
                this.mtdverificaliberacaosistema();
    
            },
            atzcoletor(val){
                if (val === true){
                    this.lstitenscoletor = this.$store.state.atzcoletor.itenscoletor;
                    util.atzitenscoletor(this, this.$store.state.atzcoletor.itenscoletor, false);
                }
            },
            verificarlib(val){
                if (val === true){
                   this.mtdverificaliberacaosistema(); 
                }
            }
        }
    };
</script>
<style>
    .Azul{
        color: #4250f2;
    }
    .Amarelo{
        color: #ffbc00;
    }
    .Verde{
        color: #0acf97;
    }
    .Vermelho{
        color: #f82b54;
    }
    #mySidenav{
        background: #31353D !important;
    }
    .dv-borda-bottom{
        border-bottom: 1px solid #3a3f48;
    }
    .dados-usuario{
        padding: 15px 0 15px 0px;
    }
    #fantasia-filial{
        position: absolute;
        left: 50px;       
    }
    @media screen and (max-width: 325px) {
        #fantasia-filial{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            position: absolute;
            left: 50px;
            width: 160px;        
        }        
    }        
    @media screen and (max-width: 450px) {
        #fantasia-filial{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            position: absolute;
            left: 50px;
            width: 160px;        
        }        
    }
    #nome-empresa{
        width: 175px;
        text-transform: uppercase;
        font-size: 16px;
        color: #b8bfce;
        padding-bottom: 5px;;
    }
    #img-foto-usuario{
        border: 1px solid #3a3f48;
        border-radius: 5px;
        width: 50px !important;
        height: 50px !important;
    }
    #nome-usuario{
        margin-top: 5px;
        font-size: 16px;
        color: #b8bfce;
    }
    #grupo-usuario{
        margin-top: -5px;
        font-size: 12px;
        color: #b8bfce;
        font-weight: lighter;
    }    
    #grupo-lista-menu{
        cursor: pointer;
        list-style-type: none;
        padding-left: 0px;
    }
    #grupo-lista-menu>li>a{
        color: #593196 !important; 
        font-size: 15px;               
        padding: 10px;
        padding-left: 30px;
    }    
    #grupo-lista-menu>li>a:hover{
        color: #b8bfce;
        text-shadow: 0px 0px 2px #b8bfce;
    }
    .grupo-lista-submenu{
        background: #3a3f48;
        cursor: pointer;
        list-style-type: none;
        padding-left: 55px;
    }
    .grupo-lista-submenu>li>a{
        color: #818896; 
        font-size: 15px;               
        padding: 5px;        
    }    
    .grupo-lista-submenu>li>a:hover{
        color: #1E8CBE;
        text-shadow: 0px 0px 10px #1E8CBE;        
    }     
    .grupo-lista-pesquisa{
        background: #3a3f48;
        cursor: pointer;
        list-style-type: none;
        padding-left: 5px;
        padding-right: 5px;
    }
    .grupo-lista-pesquisa>li>a{
        color: #818896; 
        font-size: 12px;               
        padding: 5px;        
    }    
    .grupo-lista-pesquisa>li>a:hover{
        color: #1E8CBE;
        text-shadow: 0px 0px 10px #1E8CBE;        
    }
    .icone-rotate{
        font-size: 10px;
        float: right;
        margin-right: 10px;
        margin-top: 5px;
        transition: 0.5s;
    }
    .grupo-lista-submenu>li>a>i{
        font-size: 8px;
        position: relative;
        top: -2px;
    }
    [data-toggle="collapse"][aria-expanded="true"] > .icone-rotate{
            -webkit-transform: rotate(90deg);
            -moz-transform: rotate(90deg);
            -ms-transform: rotate(90deg);
            -o-transform: rotate(90deg);
            transform: rotate(90deg);
            transition: 0.5s;            
    }       
    #edpesquisamenu, #btpesquisarmenu{
        background: #3a3f48;
        border-color: transparent;
        box-shadow: none;  
        color: #818896;              
    }
    .closebtn{
        cursor: pointer;
        position: absolute;
        left: 85%;
        color: #818896;
        top: -8px;
        font-size: 20px;   
    }
    .closebtn:hover{
        color: #b8bfce;
        text-shadow: 0px 0px 2px #b8bfce;        
    }
    .icone-menu{
        font-size: 18px;
        margin-right: 10px;
    }   
    #lst-icones-menu-nav{
        margin-top: -34px;
        margin-bottom: -10px;
        margin-right: 22px;
    }
    #lst-icones-menu-nav > li{
        display: inline-block;
        margin-left: 2px;
    }
    @media (max-width: 991px) {
        #lst-icones-menu-nav{
            padding-left: 5px;
            margin-top: 0px;
            margin-bottom: -5px;
        }
    }
    .icone-menu-bar{
        transition: 0.2s; 
        cursor: pointer;
        font-size: 18px;
        margin-left: 20px;
    }     
    .icone-menu-bar:hover{ 
        transition: 0.2s;  
        color: #b8bfce;
        text-shadow: 0px 0px 5px #b8bfce;               
    }
    .drop-notificacoes{
        border: 0px!important;
        left: -240px!important;
        border: 0px!important;
        padding: 0px!important;
        width: 300px !important;
        top: 40px!important;        
    }
    .drop-mensagens{
        border: 0px!important;
        left: -240px!important;
        border: 0px!important;
        padding: 0px!important;
        width: 300px !important;
        top: 40px!important;        
    }
    .badge-notfusu{
        font-size: 10px!important;
        min-width: 20px;
        border-radius: 10px;
        position: absolute;
        top: -5px;
        left: 30px;
    }
    .badge-itens-coletor{
        background: #4250f2!important;
        font-size: 10px!important;
        min-width: 20px;
        position: absolute;
        top: 10px;
        margin-left: -5px;
    }        
    @media (min-width: 992px) {
        .animate {
            animation-duration: 0.3s;
            -webkit-animation-duration: 0.3s;
            animation-fill-mode: both;
            -webkit-animation-fill-mode: both;
        }
    }

    @keyframes slideIn {
        0% {
            transform: translateY(1rem);
            opacity: 0;
        }
        100% {
            transform:translateY(0rem);
            opacity: 1;
        }
        0% {
            transform: translateY(1rem);
            opacity: 0;
        }
    }

    @-webkit-keyframes slideIn {
        0% {
            -webkit-transform: transform;
            -webkit-opacity: 0;
        }
        100% {
            -webkit-transform: translateY(0);
            -webkit-opacity: 1;
        }
        0% {
            -webkit-transform: translateY(1rem);
            -webkit-opacity: 0;
        }
    }

    .slideIn {
    -webkit-animation-name: slideIn;
    animation-name: slideIn;
    }

.tit-notificacao{
    position: absolute;
    font-size: 15px;
    color: #6c757d;
    top: 10px;
    left: 65px;
    max-width: 220px; 
    overflow: hidden; 
    text-overflow: ellipsis; 
    white-space: nowrap;    
}
.data-notificacao{
    font-size: 10px;
    font-weight: 500;
    color: #98a6ad;
    position: absolute;
    left: 65px;
    top: 35px;  
}
.img-usuario-notificacao{
    width: 35px!important;
    height: 35px!important;
    margin-left: -5px!important;
}
.img-usuario-notificacao-esp{
    width: 20px!important;
    height: 20px!important;
    margin-left: -5px!important;
}
#limpar-notificacao{
    float: right;
    font-size: 12px;
    margin-top: 2px;
    cursor: pointer; 
    transition: 0.5s;   
}
#limpar-notificacao:hover{
    filter: brightness(80%)!important;
    transition: 0.5s;
}
#img-usuario-def{
    position: relative;
    background-color: #ddd;
    border-radius: 100%;
    height: 220px;
    object-fit: cover;
    width: 220px;
    cursor: pointer;
}
.icon-validade-cert{
    font-size: 45px;
    color: #f82b54;
}
#mdleditaitemcoletor{
    z-index: 1051!important;
}
/* #dvalertasistema{
    display: block;
    z-index: 97;
    margin-top: 65px;
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: -60px;
} */
@media (max-width: 400px) {
    #dvconteudo-side-nav-mini {
      display: none;
    }
   
  }


  .bolinha-notificacao {
        background-color: #593196  !important;
        color: white;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
    }
  
</style>